import RestApiModel from "@/api/Model/RestApiModel";

class UserInformation extends RestApiModel {
  static getResourceEndpoint() {
    return '/UserInformation';
  }
}

export default UserInformation;
